
import { colors } from './../colors';
import { Log } from '@cc/pixi-app';
import { session } from '../session';
import { EventEmitter } from 'events';

const data = {
    versionNumber: "0.9.2",
    showTutorial: true,
    perfLevel: 3,
    dna: null,
    colors: {
        hair: 0,
        eyes: 0,
        skin: 0,
        lips: 0
    },
    packProgress: {
        packId : ""
    },
    completedMissions: {
        packId : ""
    },
    score: 0
};

class StorageManager {
    constructor(){
        this.load();
        this.save();

        this.ee = new EventEmitter();
    }

    get packs(){
        return this.data.packProgress;
    }

    get completeMissions(){
        return this.data.completedMissions;
    }

    setMissionComplete(packId, missionId){
        //setting available missions
        let keys = Object.keys(this.packs).indexOf(packId);
        if (keys === -1){
            Object.assign(this.packs, {[packId]: []});
        }
        if (this.packs[packId].indexOf(missionId) === -1){
            this.packs[packId].push(missionId);
            this.save();
        }
        console.warn("level " + missionId + " complete");
    }

    unlockMission(pack, mission){
        //passing mission to unlock
        if (mission.missionNr < pack.missions.length){
            this.setMissionComplete(pack.id, pack.missions[mission.missionNr].id);
        }

        //setting mission completion
        let missionKeys = Object.keys(this.completeMissions).indexOf(pack.id);
        if (missionKeys === -1){
            Object.assign(this.completeMissions, {[pack.id]: []});
        }
        if (this.completeMissions[pack.id].indexOf(mission.id) === -1){
            this.completeMissions[pack.id].push(mission.id);
            this.save();
        }
    }

    checkMissionComplete(packId, missionId) {
        if (this.packs[packId] && !this.packs[packId].includes(missionId)) {
            this.packs[packId].push(missionId);
        }
    }

    setDna(dna){
        this.data.dna = dna;
        this.save();
    }

    setColors(colors){
        this.data.colors = colors;
        this.save();
    }

    getPackSaveData(packId){
        this.load();
        return this.packs[packId];
    }

    getScore(){
        this.load();
        return this.data.score;
    }

    increaseScore(score){
        this.data.score += score;
        this.save();
        this.ee.emit("scoremodified");
    }

    setScore(score){
        this.data.score = score;
        this.save();
        this.ee.emit("scoremodified");
    }

    getPerfLevel(){
        this.load();
        return this.data.perfLevel;
    }

    setPerfLevel(level){
        this.data.perfLevel = level;
        this.save();
    }

    setShowTutorial(bool){
        this.data.showTutorial = bool;
        this.save();
    }

    getShowTutorial(){
        this.load();
        return this.data.showTutorial;
    }

    save(){
        window.localStorage.setItem("nickjr-worlds", JSON.stringify(this.data));
    }

    load(){
        var d = JSON.parse(window.localStorage.getItem("nickjr-worlds"));
        if (d !== null){
            if (d.versionNumber === data.versionNumber){
                this.data = d;
            }
            else{
                this.data = data;
            }
        }
        else{
            this.data = data;
        }
    }
}

export let storageManager = new StorageManager();
